import { useMemo } from "react"

import { useProductObjCache } from "./useProductObjCache"

export function useCachedProduct(variantKey: string | null | undefined) {
  const { getCacheForVariantKey } = useProductObjCache()

  return useMemo(() => {
    if (!variantKey) return null
    return getCacheForVariantKey(variantKey)
  }, [getCacheForVariantKey, variantKey])
}
